import { isTaskStatus } from "./workflow.ts";

export type Layout = "list" | "board";
export type ViewSettings = {
  milestoneDiagram?: { layout?: "diagram" | "list"; status?: string; assigneeId?: string };
  layout: Layout;
  hideCompletedTasks: boolean;
  hideCompletedIssues: boolean;
  collapsedIds: string[];
};
export const DEFAULT_VIEW: ViewSettings = {
  layout: "list",
  hideCompletedTasks: true,
  hideCompletedIssues: true,
  collapsedIds: [],
};

const record = (value: unknown): Record<string, unknown> => value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
const oneOf = <T extends string>(value: unknown, values: readonly T[], fallback: T): T => values.includes(value as T) ? value as T : fallback;

/** Accept only current settings; stale grouping/filter fields cannot hide items. */
export function normalizeView(value: unknown): ViewSettings {
  const saved = record(value);
  const diagram = record(saved.milestoneDiagram);
  return {
    layout: oneOf(saved.layout, ["list", "board"], DEFAULT_VIEW.layout),
    hideCompletedTasks: typeof saved.hideCompletedTasks === "boolean" ? saved.hideCompletedTasks : DEFAULT_VIEW.hideCompletedTasks,
    hideCompletedIssues: typeof saved.hideCompletedIssues === "boolean" ? saved.hideCompletedIssues : DEFAULT_VIEW.hideCompletedIssues,
    collapsedIds: Array.isArray(saved.collapsedIds) ? [...new Set(saved.collapsedIds.filter((id): id is string => typeof id === "string" && id.length > 0 && id.length <= 200))] : [],
    ...(saved.milestoneDiagram ? { milestoneDiagram: {
      layout: oneOf(diagram.layout, ["diagram", "list"] as const, "diagram"),
      status: isTaskStatus(diagram.status) ? diagram.status : undefined,
      assigneeId: typeof diagram.assigneeId === "string" ? diagram.assigneeId : undefined,
    } } : {}),
  };
}

export const treeViewKey = (projectId: string, kind: "docs" | "tasks" | "issues") => `tree:${projectId}:${kind}`;
